import { render, staticRenderFns } from "./login.page.vue?vue&type=template&id=552e3d89&"
import script from "./login.page.vue?vue&type=script&lang=ts&"
export * from "./login.page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports